import React from 'react';
import { getConstant } from '../../../../utils/constants';
import Tag from '../../../../components/Display/Tag';
import styles from "../../cards.module.scss"

function InternalResourceItem({ resource, handleClickResource, layout }) {
  return (
    <div
      className={`${styles.projectCard} ${layout === "grid" ? styles.projectCardGrid : ''}`}
      onClick={handleClickResource}>
      <div className={styles.contentContainer}>
        <div className={styles.topInfo}>
          <p className={styles.title}>{resource.title}</p>
          <span className={styles.subtitle}>
            {resource.author}</span>
        </div>

        <div className={styles.tagList}>
          <Tag
            tag={{
              label: getConstant('solarys.resourceTypes', resource.type).label,
              bgColor: 'bg-green-700'
            }}
          />

          <Tag
            tag={{
              label: getConstant('solarys.cities', resource.city).label,
              bgColor: 'bg-purple-800'
            }}
          />
          {resource.public_list.map((o, key) => (
            <Tag
              key={key}
              tag={{
                label: o.label,
                bgColor: 'bg-yellow-500'
              }}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

export default InternalResourceItem;
